import React, { useEffect } from 'react';
import { GlobalStyles, ThemeProvider } from '@mui/material';
import defaultTheme from './themes/default';
import { AppRouter } from './routes/Router';
import { initCsrfCookie } from './api/authApi';
import { SnackbarProvider } from 'notistack';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useDateLocale } from './hooks/useDateLocale';

const App = (): JSX.Element | null => {
  useEffect(() => {
    initCsrfCookie();
  }, []);

  useDateLocale();

  return (
    <ThemeProvider theme={defaultTheme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <SnackbarProvider />
        <GlobalStyles
          styles={(theme) => ({
            body: {
              backgroundColor: theme.palette.background.default,
              color: theme.palette.text.primary,
              margin: 0,
              padding: 0,
            },
          })}
        />
        <AppRouter />
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App;
